import React from "react";
import EventFormV2 from "./EventFormV2";

export default function CreateEvent2() {
  return (
    <div className="px-customPaddingMobile lg:pl-8 lg:pr-[87px] pb-[80px]">
      <EventFormV2 />
    </div>
  );
}
